/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

export const changeTaxable = createAsyncThunk(
  'products/changeTaxable',
  async ({ productId, variantId = 'default', taxable }, {
    extra: {
      sdk, Logger, showErrorDialog, utils,
    },
  }) => {
    try {
      const { data } = await sdk.products.changeTaxable(productId, variantId, taxable);
      return data;
    } catch (error) {
      const errorMessage = utils.getDataFromResponceError(error, 'msg') || 'Can not change product taxable';
      showErrorDialog(errorMessage);
      Logger.error(new Error('Error product change taxable'), { error }, [
        'ChangeTaxableProductFailed',
        { errorMessage: errorMessage || 'NoMessage' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(
      changeTaxable.pending,
      (state, { meta }) => {
        const { productId } = meta.arg;
        state.items.forEach((product) => {
          if (product._id === productId) {
            product.isBusy = true;
          }
        });
      },
    )
    .addCase(
      changeTaxable.fulfilled,
      (state, { meta, payload }) => {
        const { productId } = meta.arg;
        state.items.forEach((product) => {
          if (product._id === productId) {
            product.isBusy = false;
            product.variants = payload.variants;
            product.defaultVariant = payload.defaultVariant;
          }
        });
      },
    )
    .addCase(
      changeTaxable.rejected,
      (state, { meta, error }) => {
        state.items.forEach((product) => {
          if (product._id === meta.arg.productId) {
            product.isBusy = false;
          }
        });
        state.error = error;
      },
    );
};
